import ReactDOM from "react-dom/client";
import React from "react";
import { Provider } from "react-redux";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupStore } from "./redux/store";
import { routeTree } from "./routeTree.gen";
import "./main.sass";
// Brand design tokens (--mp-*) for the migrated @monitor/platform components.
import "@monitor/platform/tokens.css";
// App-scoped shadcn semantic tokens (--primary, --radius, ...) that the platform
// ui/* components (DatePicker, Popover, Calendar) read from the consuming app.
import "./platform-ui-tokens.css";
import "./languages/i18n";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { syncStoreWithRouter } from "./utils/routerStoreSync";

const queryClient = new QueryClient();

// Create store
const store = setupStore();

// Create router with context
export const router = createRouter({
  routeTree,
  context: {
    store,
    queryClient
  },
  defaultPreload: "intent"
});

// Sync Redux state changes with router guards
syncStoreWithRouter(store, router);

async function enableMocking() {
  return;
  // if (import.meta.env.DEV) {
  //   const { worker } = await import('./mocks/browser');
  //   return worker.start();
  // }
}

enableMocking().then(() => {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Root element not found");
  ReactDOM.createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ErrorBoundary>
          <React.StrictMode>
            <RouterProvider router={router} />
          </React.StrictMode>
        </ErrorBoundary>
      </Provider>
    </QueryClientProvider>
  );
});
